export default "__VITE_ASSET__DtecsG4l__"